import React, { useState } from 'react';
import { storePassphrase } from '../utils/encryption';

function PassphrasePrompt({ onSuccess, onCancel, message = "Enter your encryption passphrase to access this data:" }) {
  const [passphrase, setPassphrase] = useState('');
  const [error, setError] = useState('');

  const handleSubmit = (e) => {
    e.preventDefault();
    if (passphrase.length < 8) {
      setError('Passphrase must be at least 8 characters');
      return;
    }
    storePassphrase(passphrase);
    setError('');
    onSuccess(passphrase);
  };

  return (
    <div className="dialog-overlay">
      <div className="dialog-content">
        <h3 className="dialog-title">Enter Passphrase</h3>
        <p>{message}</p>

        <form onSubmit={handleSubmit}>
          <div className="form-group">
            <label htmlFor="passphrase-input">Passphrase</label>
            <input
              type="password"
              id="passphrase-input"
              value={passphrase}
              onChange={(e) => setPassphrase(e.target.value)}
              className="form-input"
              placeholder="Enter your passphrase"
              autoFocus
            />
            {error && <div className="error-message">{error}</div>}
          </div>

          <div className="dialog-buttons">
            <button
              type="button"
              onClick={onCancel}
              className="btn btn-secondary"
            >
              Cancel
            </button>
            <button
              type="submit"
              className="btn btn-save"
              disabled={passphrase.length < 8}
            >
              Unlock Data
            </button>
          </div>
        </form>
      </div>
    </div>
  );
}

export default PassphrasePrompt;